import React, {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {UploadButton} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/UploadButton/UploadButton';
import {DeleteButton} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/DeleteButton/DeleteButton';
import {UPDATE_PRISTINE_UYO} from '~/CreateFabricInvitation/reducers/fabricDesign/constants';
import {useImageReset} from '~/CreateFabricInvitation/components/PhotoEditor/common/useImageReset';

export const ActionButtons = ({canvas, id, editorDisabled}) => {
  const dispatch = useDispatch();
  const {resetImage} = useImageReset(canvas);

  const imageUploadedCallback = useCallback(
    (uploadedUyo) => {
      dispatch({
        type: UPDATE_PRISTINE_UYO,
        payload: {pristineUyo: false, id, objects: canvas.getObjects()},
      });
      canvas.setActiveObject(uploadedUyo).renderAll();
      resetImage();
    },
    [canvas, dispatch, id, resetImage]
  );

  return (
    <div className="uyo-control-actions">
      <div className="uyo-control-action-button">
        <UploadButton
          showFullWidth
          btnText="Swap photo"
          id={id}
          index={id}
          callback={imageUploadedCallback}
        />
      </div>
      <div className="uyo-control-action-button">
        <DeleteButton btnText="Delete" disabled={editorDisabled} semibold />
      </div>
    </div>
  );
};
